/**
 * GENEL BAKIŞ (Çekidüzen Adım 0) — tek giriş kapısı:
 *   Çok siteli kullanıcı → FİLO görünümü (tüm siteler; tıkla → kokpit).
 *   Tek siteli kullanıcı → doğrudan KOKPİT (filoyu hiç görmez; sadelik).
 * Eski Dashboard+Portföy ikiliğinin yerini alır — "nereden başlayacağım?"
 * sorusunun tek cevabı bu ekrandır.
 */
import { useListDomains } from "@workspace/api-client-react";
import Portfolio from "./portfolio";
import Dashboard from "./dashboard";
import { Loader2 } from "lucide-react";

export default function GenelBakis() {
  const { data: domains, isLoading } = useListDomains();
  if (isLoading && !domains) {
    return <div className="py-24 text-center text-sm text-gray-400"><Loader2 className="mx-auto mb-2 h-5 w-5 animate-spin" />Siteler yükleniyor…</div>;
  }
  // Tek site (ya da hiç site — Dashboard ekleme akışını yönetir) → kokpit
  if ((domains?.length ?? 0) <= 1) return <Dashboard />;
  return <Portfolio />;
}
